
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";
import LoadingOverlay from "@/components/overlay/LoadingOverlay.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import CategoryModel from "@/models/CategoryModel";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";
import ModalAddManpower from "./ModalAddManpower.vue";
import ModalAddMaterial from "./ModalAddMaterial.vue";
import { Ref } from "vue-property-decorator";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
import ActivityModel from "@/models/createTicket/ActivityModel";

@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,
        LoadingOverlay,
        ValidationObserver,
        ValidationProvider,
        TextFloating,
        SelectAutocomplete,
        ModalAddMaterial,
        ModalAddManpower,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.id);
        this.loadTechnician(this.$route.params.id);
    }
    utils = utils;
    titlePage = "Activities";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";

    isActiveSubject = false;
    isActiveDateStart = false;
    isActiveTimeStart = false;
    isActiveDateEnd = false;
    isActiveTimeEnd = false;

    isActiveExplanation = false;

    ticket1: ActivityModel = new ActivityModel();
    ticket: WorkorderModel = new WorkorderModel();

    technicians: any = [];

    attachments: AttachmentModel[] = [];

    isTypeActive = false;

    submitting = false;

    // addMaterial() {
    goBack() {
        this.$router.back();
    }
    loadTechnician(workorder_id) {
        api.options
            .getTechnicians(workorder_id)
            .then((response) => {
                // console.log(response);
                if (response.data.code === 200) {
                    this.technicians = response.data.data.map((item) => {
                        return {
                            id: item.id,
                            name: item.name,
                            selected: false,
                            is_pic: item.is_pic,
                        };
                    });
                }
            })
            .catch((err: any) => {
                this.$swal("Error", err?.response?.data?.message, "error");
            });
    }
    handleSubmit() {
        // Validate start and end date/time
        if (this.ticket1.date_start_at && this.ticket1.time_start_at && 
            this.ticket1.date_end_at && this.ticket1.time_end_at) {
            const startDateTime = new Date(`${this.ticket1.date_start_at}T${this.ticket1.time_start_at}`);
            const endDateTime = new Date(`${this.ticket1.date_end_at}T${this.ticket1.time_end_at}`);
            
            if (endDateTime <= startDateTime) {
                this.$swal("Warning", "End date and time should be greater than date and time", "warning");
                return;
            }
        }

        const technicians = this.technicians
            .filter((item) => {
                return item.selected;
            })
            .map((item1) => {
                return {
                    id: item1.id,
                    is_pic: item1.is_pic,
                };
            });
        if (technicians.length === 0) {
            this.$swal("Warning", "Technician is required", "warning");
            return;
        }
        if(this.attachments.length == 0){
            this.$swal("Warning", "Attachment is required", "warning");
            return;
        }
        if(this.attachments.some((item) => item.image == null)){
            this.$swal("Warning", "Please upload attachment", "warning");
            return;
        }

        const data = {
            work_orders_id: Number(this.$route.params.id),
            subject_activities: this.ticket1.subject_activities,
            date_start_at: this.ticket1.date_start_at,
            time_start_at: this.ticket1.time_start_at,
            date_end_at: this.ticket1.date_end_at,
            time_end_at: this.ticket1.time_end_at,
            report_explanation: this.ticket1.report_explanation,
            attachments: this.attachments.map((item) => {
                return {
                    path: item.image || "",
                    label: item.desc || "",
                };
            }),
            technicians: technicians,
        };

        // console.log(this.attachments);

        // console.log(data);
        this.submitting = true;
        api.ticket
            .saveActivity(data)
            .then((response) => {
                if (response.data.code === 200) {
                    this.$router.back();
                } else {
                    this.$swal("Peringatan", response.data.message, "warning");
                }
            })
            .catch((err: any) => {
                this.$swal("Error", err.data.message, "error");
            })
            .finally(() => {
                this.submitting = false;
            });
    }

    addUploadImgRow() {
        const images = new AttachmentModel();
        this.attachments.push(images);
    }
    removeUploadRow(i: number) {
        this.attachments.splice(i, 1);
    }

    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    cekSubject() {
        if (this.ticket1.subject_activities) {
            this.isActiveSubject = true;
        } else {
            this.isActiveSubject = false;
        }
    }

    cekDateStart() {
        if (this.ticket1.date_start_at) {
            this.isActiveDateStart = true;
        } else {
            this.isActiveDateStart = false;
        }
    }

    cekTimeStart() {
        if (this.ticket1.time_start_at) {
            this.isActiveTimeStart = true;
        } else {
            this.isActiveTimeStart = false;
        }
    }

    cekDateEnd() {
        if (this.ticket1.date_end_at) {
            this.isActiveDateEnd = true;
        } else {
            this.isActiveDateEnd = false;
        }
    }

    cekTimeEnd() {
        if (this.ticket1.time_end_at) {
            this.isActiveTimeEnd = true;
        } else {
            this.isActiveTimeEnd = false;
        }
    }

    cekExplanation() {
        if (this.ticket1.report_explanation) {
            this.isActiveExplanation = true;
        } else {
            this.isActiveExplanation = false;
        }
    }

    get colorStatus() {
        if (this.ticket.status === "new") {
            return "cl-red";
        } else {
            return "cl-green-light";
        }
    }
    get pitaStatus() {
        if (this.ticket.status === "new") {
            return "new";
        } else {
            return "on-progress";
        }
    }
}
